import {
  ALL_PROJECT_TASKS,
  ALL_PROJECTS_TABLE,
  FETCH_ALL_FTE_DETAILS,
  // BATCH_QC_SAMPLE_DETAILS,
  // BATCH_UNIT_DETAILS,
  FETCH_ALL_WORK_ITEM_DETAILS,
  FETCH_ALL_WORK_ITEM_DETAILS_LOADING,
  FETCH_PENDING_DELIVERABLES,
  FETCH_REVIEW_COMMENTS,
  FORECAST_AUDIT_DATA,
  FORECAST_FILTER_DATA,
  PROJECT_DELIVERABLES_TABLE,
  PROJECT_STRUCTURED_DATA,
  REMIND_PENDING_DELIVERABLE,
  UPDATE_FTE_DETAILS,
} from "../../actions/types";

const intialState = { backdropText: "Please wait..." };

export default function (state = intialState, action) {
  switch (action.type) {
    case ALL_PROJECTS_TABLE:
      return {
        ...state,
        allProjects: action.payload,
      };
    case PROJECT_DELIVERABLES_TABLE:
      return {
        ...state,
        projectDeliverables: action.payload,
      };
    case FETCH_REVIEW_COMMENTS:
      return {
        ...state,
        reviewComments: action.payload,
      };
    case FETCH_ALL_WORK_ITEM_DETAILS:
      return {
        ...state,
        workItemDetails: action.payload,
      };
    case FETCH_ALL_WORK_ITEM_DETAILS_LOADING:
      return {
        ...state,
        workItemDetailsLoading: action.payload,
      };
    case PROJECT_STRUCTURED_DATA:
      return {
        ...state,
        projectStructuredData: action.payload,
      };
      case REMIND_PENDING_DELIVERABLE:
        return {
          ...state,
          remindPendingDeliverable: action.payload,
        };
  case FETCH_PENDING_DELIVERABLES:
            return {
              ...state,
              pendingDeliverables: action.payload,
      };
    case FORECAST_FILTER_DATA:
      return {
        ...state,
        forecastFilterData: action.payload,
      }
    case FORECAST_AUDIT_DATA:
      return {
        ...state,
        forecastAuditData: action.payload,
      }
      case FETCH_ALL_FTE_DETAILS:
        return {
          ...state,
          fteTableData: action.payload,
      }
      case UPDATE_FTE_DETAILS:
        return {
          ...state,
          updatedFTE: action.payload,
      }
      case ALL_PROJECT_TASKS:
        return {
          ...state,
          allProjectsTasks: action.payload,
        };
    default:
      return state;
  }
}
